import React, {useEffect, useState} from 'react';
import {CSVLink} from 'react-csv';
import ExportCSVData from "../../../common/ui/export-csv-data";
import {PINTEREST_PIN_BULK_UPLOAD_CSV_HEADER} from "../../constants/pinterest-pin-sync.constant";
import {prepareBulkUploadPinsCSVData} from '../../utils/pinterest-pin-util';

const ExportBulkPinterestPins = ({pinterestPinSync}) => {
    const [data, setData] = useState(null);

    useEffect(() => {
        const pinsData = prepareBulkUploadPinsCSVData(pinterestPinSync);
        setData(pinsData);
    }, [pinterestPinSync]);


    return (
        <div>
            {data &&
                <ExportCSVData
                    data={data}
                    headers={PINTEREST_PIN_BULK_UPLOAD_CSV_HEADER}
                    filename={`exported-data-${pinterestPinSync.id}.csv`}/>

            }
        </div>
    );
};

export default ExportBulkPinterestPins;
